{
  "app": {
    "name": "Delta WorkForce",
    "tagline": "Plataforma de personal para Servicios Generales de Stanford"
  },
  "nav": {
    "home": "Inicio",
    "workOrders": "Órdenes de trabajo",
    "scan": "Escanear",
    "timecards": "Horarios",
    "notifications": "Notificaciones",
    "whatsNew": "Novedades",
    "approvals": "Aprobaciones",
    "team": "Equipo",
    "assets": "Activos",
    "locations": "Ubicaciones",
    "map": "Mapa",
    "crew": "Personal",
    "schedule": "Calendario",
    "parts": "Repuestos",
    "tools": "Herramientas",
    "vendors": "Proveedores",
    "leaderboard": "Clasificación",
    "kudos": "Reconocimientos",
    "messages": "Mensajes",
    "feedback": "Comentarios",
    "insights": "Análisis",
    "reports": "Informes",
    "communications": "Redactor de comunicados",
    "howto": "Borradores de guías",
    "forms": "Formularios",
    "admin": "Administración",
    "settings": "Configuración",
    "integrations": "Integraciones",
    "more": "Más",
    "invoiceQueue": "Cola de facturas",
    "dispatch": "Despacho",
    "fleetCalendar": "Calendario de flota",
    "vehicles": "Vehículos",
    "fleetDashboards": "Paneles de flota",
    "approvalsQueue": "Cola de aprobaciones",
    "serviceWindows": "Ventanas de servicio",
    "fleetAdmin": "Admin. de flota",
    "lifecycle": "Ciclo de vida",
    "transfers": "Transferencias",
    "myVehicles": "Mis vehículos",
    "myApprovals": "Aprobaciones pendientes",
    "approvalHistory": "Historial",
    "impersonate": "Suplantar",
    "dashboardEditor": "Editor de inicio",
    "automations": "Automatizaciones",
    "pmSchedules": "Programación PM",
    "workforceCalendar": "Calendario",
    "help": "Centro de ayuda"
  },
  "nav_desc": {
    "home": "Tu panorama diario: qué hacer a continuación, rápido.",
    "workOrders": "Trabajos abiertos, estado, peligros e historial.",
    "timecards": "Registra horas contra órdenes de trabajo o tiempo general.",
    "approvals": "Revisa las solicitudes pendientes que te corresponden.",
    "team": "Plantilla, asignaciones y quién está de turno.",
    "insights": "Tendencias de órdenes, tiempo y equipos.",
    "reports": "Informes guardados y exportaciones para interesados.",
    "communications": "Comunicados con asistencia de IA para inquilinos y partes interesadas.",
    "howto": "Captura y refina procedimientos operativos estándar.",
    "forms": "Formularios de inspección y cumplimiento por oficio.",
    "assets": "Consulta de equipos, manuales e historial de servicio.",
    "locations": "Edificios, salas e información del sitio.",
    "map": "Mapa del campus con trabajos y activos activos.",
    "crew": "Plantilla del equipo, certificaciones y contactos.",
    "schedule": "Calendario de turnos y asignaciones.",
    "parts": "Catálogo de repuestos, existencias y reabastecimiento.",
    "tools": "Préstamo de herramientas, calibración e inventario.",
    "vendors": "Contratistas externos, contratos y contactos.",
    "leaderboard": "Competencia amistosa entre equipos.",
    "kudos": "Reconoce el buen trabajo de los compañeros.",
    "messages": "Canales y conversaciones directas.",
    "whatsNew": "Actualizaciones recientes de la plataforma y notas de versión.",
    "settings": "Perfil, notificaciones y preferencias.",
    "integrations": "Maximo, SSO y otras conexiones de sistemas.",
    "admin": "Configuración del inquilino, usuarios y registro de auditoría.",
    "more": "Todas las aplicaciones disponibles para ti.",
    "invoiceQueue": "Revisión de coincidencia triple para facturas de proveedores.",
    "dispatch": "Asigna órdenes de trabajo a tus técnicos.",
    "fleetCalendar": "Citas de preparación y programación de proveedores.",
    "vehicles": "Vehículos de flota, retiros y historial de servicio.",
    "fleetDashboards": "Fuera de servicio, OT vencidas, rendimiento de proveedores.",
    "approvalsQueue": "Seguimiento y escalamiento de aprobaciones de clientes.",
    "serviceWindows": "Ventanas de servicio de proveedores, ofertas de turnos y reservas de operadores.",
    "fleetAdmin": "Seguros, registro, arrendamientos, transferencias, disposiciones.",
    "lifecycle": "Línea de tiempo del ciclo de vida del vehículo, TCO y sub-registros.",
    "transfers": "Transferencias de vehículos entre departamentos y aprobaciones.",
    "myVehicles": "Los vehículos de tu departamento y estado del servicio.",
    "myApprovals": "Estimaciones de reparación esperando tu aprobación.",
    "approvalHistory": "Decisiones de aprobación pasadas y registros de servicio.",
    "impersonate": "Ver la app como otro usuario (solo lectura).",
    "dashboardEditor": "Configura los widgets del inicio por rol.",
    "automations": "Trabajos programados y tareas de automatización.",
    "pmSchedules": "Programación de mantenimiento preventivo recurrente.",
    "workforceCalendar": "Horarios, solicitudes de permiso y horas extra.",
    "help": "Guías interactivas de flujos de trabajo."
  },
  "actions": {
    "save": "Guardar",
    "saveDraft": "Guardar borrador",
    "cancel": "Cancelar",
    "submit": "Enviar",
    "delete": "Eliminar",
    "edit": "Editar",
    "create": "Crear",
    "add": "Añadir",
    "remove": "Quitar",
    "assign": "Asignar",
    "unassign": "Desasignar",
    "approve": "Aprobar",
    "reject": "Rechazar",
    "close": "Cerrar",
    "back": "Atrás",
    "next": "Siguiente",
    "done": "Hecho",
    "search": "Buscar",
    "filter": "Filtrar",
    "clear": "Limpiar",
    "upload": "Subir",
    "takePhoto": "Tomar foto",
    "translate": "Traducir",
    "showOriginal": "Ver original",
    "viewAll": "Ver todo",
    "viewMore": "Ver más",
    "loading": "Cargando…",
    "retry": "Reintentar",
    "signIn": "Iniciar sesión",
    "signOut": "Cerrar sesión"
  },
  "status": {
    "open": "Abierta",
    "assigned": "Asignada",
    "inProgress": "En curso",
    "onHold": "En espera",
    "completed": "Completada",
    "closed": "Cerrada",
    "cancelled": "Cancelada",
    "available": "Disponible",
    "onLeave": "Ausente",
    "offDuty": "Fuera de servicio"
  },
  "priority": {
    "emergency": "Emergencia",
    "urgent": "Urgente",
    "high": "Alta",
    "medium": "Media",
    "low": "Baja"
  },
  "fields": {
    "description": "Descripción",
    "location": "Ubicación",
    "trade": "Oficio",
    "priority": "Prioridad",
    "assignedTo": "Asignado a",
    "dueDate": "Fecha límite",
    "estimatedHours": "Horas estimadas",
    "status": "Estado",
    "name": "Nombre",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "role": "Cargo",
    "notes": "Notas"
  },
  "validation": {
    "required": "Obligatorio",
    "mustBeNumber": "Debe ser un número",
    "minLength": "Muy corto",
    "maxLength": "Muy largo",
    "invalidEmail": "Correo no válido"
  },
  "notify": {
    "critical": "CRÍTICO",
    "important": "IMPORTANTE",
    "info": "INFORMACIÓN"
  },
  "common": {
    "yes": "Sí",
    "no": "No",
    "none": "Ninguno",
    "all": "Todos",
    "any": "Cualquiera",
    "unknown": "Desconocido",
    "notAvailable": "No disponible"
  },
  "settings": {
    "language": "Idioma",
    "preferences": "Preferencias",
    "profile": "Perfil",
    "theme": "Tema",
    "textSize": "Tamaño de texto",
    "textSizeHint": "Ajusta todo el texto y los elementos de la interfaz",
    "simplified": "Modo simplificado (controles y texto más grandes)",
    "themeDark": "Predeterminado",
    "themeDarkDesc": "Oscuro industrial — predeterminado",
    "themeLight": "Claro",
    "themeLightDesc": "Superficies blancas limpias",
    "themeHighContrast": "Alto contraste",
    "themeHighContrastDesc": "Negro OLED puro",
    "themeSunlight": "Luz solar",
    "themeSunlightDesc": "Máximo contraste exterior",
    "themeTechConnect": "TechConnect",
    "themeTechConnectDesc": "Rojo cardinal y oro de Stanford"
  },
  "translate": {
    "translateButton": "Traducir",
    "translating": "Traduciendo…",
    "translatedFrom": "Traducido del {{lang}}",
    "failed": "Error de traducción"
  },
  "pages": {
    "helpCenter": "Centro de ayuda",
    "helpCenterDesc": "Comprende cómo funcionan los flujos clave — quién hace qué, en qué orden y dónde.",
    "allRoles": "Todos los roles",
    "searchFlows": "Buscar flujos, roles o acciones...",
    "noFlowsFound": "No se encontraron flujos. Intenta otra búsqueda.",
    "flowNotFound": "Flujo no encontrado.",
    "backToHelp": "Volver al centro de ayuda",
    "stepsInDetail": "Pasos en detalle",
    "workOrders": "Órdenes de trabajo",
    "newWorkOrder": "Nueva orden de trabajo",
    "searchWO": "Buscar por descripción, ubicación o ID…",
    "insights": "Análisis",
    "insightsDesc": "Haz preguntas en lenguaje natural, revisa paneles y detecta anomalías.",
    "askQuestion": "Haz una pregunta",
    "askPlaceholder": "p.ej., ¿Cuántas OT de HVAC el mes pasado?",
    "ask": "Preguntar",
    "anomalies": "Anomalías",
    "compliance": "Tarjeta de cumplimiento",
    "vendors": "Proveedores",
    "forms": "Formularios",
    "formBuilder": "Constructor de formularios",
    "formDetails": "Detalles del formulario",
    "addField": "Añadir campo",
    "livePreview": "Vista previa en vivo",
    "exitPreview": "Salir de vista previa",
    "preview": "Vista previa",
    "tools": "Herramientas",
    "leaderboard": "Clasificación",
    "kudos": "Reconocimientos",
    "chooseTechmate": "Elige un compañero…",
    "reports": "Informes",
    "howToDrafts": "Borradores de guías",
    "commsDrafter": "Redactor de comunicados",
    "crew": "Personal",
    "locations": "Ubicaciones",
    "partsCatalog": "Catálogo de repuestos",
    "assets": "Activos",
    "messages": "Mensajes",
    "allChannels": "Todos los canales",
    "feedback": "Comentarios",
    "fleetVehicles": "Vehículos de flota",
    "fleetCalendar": "Calendario de flota",
    "approvalsQueue": "Cola de aprobaciones",
    "noApprovals": "No hay aprobaciones en cola",
    "pendingApprovals": "Aprobaciones pendientes",
    "noPendingApprovals": "Sin aprobaciones pendientes",
    "approvalHistory": "Historial de aprobaciones",
    "noHistory": "Sin historial aún",
    "myVehicles": "Mis vehículos",
    "noVehicles": "Sin vehículos asignados",
    "schedule": "Horario",
    "notifications": "Notificaciones",
    "markAllRead": "Marcar todo leído",
    "adminConsole": "Consola de administración",
    "integrations": "Integraciones",
    "invoiceQueue": "Cola de revisión de facturas",
    "dashboardEditor": "Editor de inicio",
    "savedChanges": "Guardado",
    "saveChanges": "Guardar cambios",
    "map": "Mapa",
    "locateMe": "Ubicarme",
    "includeClosed": "Incluir cerradas",
    "searchPins": "Buscar puntos…",
    "navigate": "Navegar"
  },
  "filters": {
    "allTrades": "Todos los oficios",
    "allStatuses": "Todos los estados",
    "allTypes": "Todos los tipos",
    "allRoles": "Todos los roles",
    "allCategories": "Todas las categorías",
    "allKinds": "Todos los tipos",
    "allFuelTypes": "Todos los combustibles",
    "allMethods": "Todos los métodos",
    "allEntityTypes": "Todos los tipos de entidad"
  },
  "trades": {
    "hvac": "HVAC",
    "plumbing": "Plomería",
    "electrical": "Electricidad",
    "general": "General"
  },
  "fleet": {
    "ice": "Combustión",
    "ev": "Eléctrico",
    "phev": "PHEV",
    "hybrid": "Híbrido",
    "available": "Disponible",
    "inService": "En servicio",
    "outForService": "Fuera de servicio",
    "scheduled": "Programado",
    "staged": "Preparado",
    "pickedUp": "Recogido",
    "returned": "Devuelto",
    "canceled": "Cancelado",
    "escalated": "Escalado",
    "aging": "Vencido",
    "pending": "Pendiente",
    "proposed": "Propuesto",
    "cedingApproved": "Cedente aprobado",
    "receivingApproved": "Receptor aprobado",
    "executed": "Ejecutado"
  },
  "calendar": {
    "leave": "Permiso",
    "overtime": "HE",
    "leaveRequest": "Solicitud de permiso",
    "overtimeRequest": "Solicitud de horas extra",
    "pendingRequests": "Solicitudes pendientes",
    "workOrders": "Órdenes de trabajo",
    "hours": "Horas",
    "reason": "Motivo",
    "tech": "Técnico",
    "hrs": "Hrs",
    "prev": "Anterior",
    "next": "Siguiente"
  },
  "widgets": {
    "myWork": "Mis órdenes de trabajo",
    "timecards": "Horarios",
    "thisWeek": "Esta semana",
    "fleetStatus": "Estado de la flota",
    "pendingApprovals": "Aprobaciones pendientes",
    "teamAvailability": "Disponibilidad del equipo",
    "recentMessages": "Mensajes recientes",
    "quickLinks": "Accesos rápidos"
  },
  "ai": {
    "formBuilder": "Constructor de formularios con IA",
    "describeForm": "Describe el formulario que necesitas",
    "generating": "Generando…",
    "generateForm": "Generar formulario"
  },
  "groups": {
    "Work": "Trabajo",
    "People": "Personal",
    "Assets": "Activos",
    "Fleet": "Flota",
    "Insights": "Análisis",
    "Admin": "Administración",
    "Preferences": "Preferencias"
  },
  "groups_desc": {
    "Work": "Tareas diarias, registro de horas y aprobaciones.",
    "People": "Equipos, personal, horarios y proveedores.",
    "Assets": "Equipos, ubicaciones, repuestos y herramientas.",
    "Fleet": "Logística vehicular, preparación y ciclo de vida.",
    "Insights": "Análisis, informes y reconocimientos.",
    "Admin": "Programación PM, automatizaciones, formularios y sistema.",
    "Preferences": "Ayuda, notas de versión y configuración personal."
  },
  "more": {
    "title": "Más",
    "subtitle": "Toca un grupo para ver sus aplicaciones."
  },
  "home": {
    "goodMorning": "Buenos días",
    "goodAfternoon": "Buenas tardes",
    "goodEvening": "Buenas noches",
    "loading": "Cargando panel…"
  },
  "roles": {
    "technician": "Técnico",
    "supervisor": "Supervisor",
    "admin": "Administrador",
    "sysadmin": "Admin. del sistema",
    "vendor_admin": "Admin. de proveedor",
    "vendor_supervisor": "Supervisor de proveedor",
    "vendor_tech": "Técnico de proveedor",
    "customer_operator": "Cliente / Operador"
  },
  "login": {
    "chooseOrg": "Elige una organización para explorar",
    "heritage": "Cada proceso que LBRE perfeccionó en TechConnect se mantiene — reconstruido para la velocidad, claridad y el futuro de las instalaciones de Stanford."
  },
  "sw": {
    "pageTitle": "Ventanas de servicio",
    "headerStats": "{{published}} publicadas · {{drafts}} borradores ({{pmDrafts}} de PM)",
    "filterAll": "Todos los estados",
    "statusDraft": "Borrador",
    "statusPublished": "Publicada",
    "statusCanceled": "Cancelada",
    "newWindow": "Nueva ventana",
    "loading": "Cargando…",
    "loadingTimes": "Cargando horarios disponibles…",
    "emptyTitle": "Sin ventanas de servicio",
    "emptyDesc": "Crea una manualmente o activa el programador automático de PM.",
    "today": "Hoy",
    "capacityLabel": "capacidad {{n}}",
    "cohortLabel": "cohorte: {{type}}",
    "vendorLabel": "proveedor {{id}}",
    "publishTitle": "Publicar",
    "cancelWindowTitle": "Cancelar ventana",
    "pmDraftsTitle": "Borradores de PM ({{count}})",
    "pmDraftsEmpty": "No hay borradores de PM. Activa el programador en Configuración del sistema.",
    "publishAllDrafts": "Publicar {{count}} borradores",
    "thisHorizon": "Este horizonte",
    "totalWindows": "Total de ventanas",
    "statsPublished": "Publicadas",
    "statsDrafts": "Borradores",
    "composerTitle": "Nueva ventana de servicio",
    "fieldStart": "Inicio",
    "fieldEnd": "Fin",
    "fieldLocation": "Ubicación",
    "locationPlaceholder": "Bahía de garaje 2 · LBRE",
    "fieldVendorId": "ID de proveedor",
    "vendorIdPlaceholder": "grainger-uuid",
    "fieldCapacity": "Capacidad",
    "fieldCohort": "Cohorte de vehículos (etiqueta de tipo)",
    "cohortPlaceholder": "transit-van · cart · bolt-ev · …",
    "publishImmediately": "Publicar inmediatamente (si no, guardar como borrador)",
    "cancel": "Cancelar",
    "saving": "Guardando…",
    "publish": "Publicar",
    "saveDraft": "Guardar borrador",
    "errInvalidTimes": "Ingresa horarios de inicio y fin válidos.",
    "errEndBeforeStart": "El fin debe ser posterior al inicio.",
    "errStartPast": "La ventana debe comenzar en el futuro.",
    "errLocationRequired": "La ubicación es obligatoria.",
    "errVendorRequired": "El ID de proveedor es obligatorio.",
    "errCapacityRange": "La capacidad debe ser entre 1 y 50.",
    "errCreateFailed": "Error al crear la ventana",
    "vendorPageTitle": "Confirmar ventanas de servicio",
    "statsPending": "Ofertas pendientes",
    "statsConfirmed": "Confirmadas",
    "statsDeclined": "Rechazadas",
    "statsTotal": "Total en horizonte",
    "vendorEmptyTitle": "Sin ofertas de ventanas de servicio",
    "vendorEmptyDesc": "Cuando el administrador de flota publique una ventana asignada a tu organización, aparecerá aquí.",
    "mixedCohort": "cohorte mixto",
    "locationColon": "Ubicación:",
    "partialConfirmed": "Parcial · {{confirmed}} de {{total}} confirmados",
    "statusDeclined": "Rechazada",
    "statusAccepted": "Aceptada",
    "confirmedCapacity": "Capacidad confirmada:",
    "save": "Guardar",
    "accept": "Aceptar",
    "partial": "Parcial",
    "decline": "Rechazar",
    "acceptTitle": "Aceptar ventana completa",
    "partialTitle": "Aceptación parcial",
    "declineTitle": "Rechazar",
    "operatorPageTitle": "Elige un horario de servicio",
    "forYourVehicle": "Para tu vehículo",
    "selectVehicle": "Selecciona un vehículo…",
    "emptyVehicleTitle": "Selecciona un vehículo",
    "emptyVehicleDesc": "Elige uno de tus vehículos para ver los horarios de servicio disponibles.",
    "noWindowsTitle": "Sin ventanas disponibles",
    "noWindowsDesc": "El administrador de flota y el proveedor aún no han confirmado horarios para este vehículo.",
    "availableSlots_one": "{{count}} horario disponible",
    "availableSlots_other": "{{count}} horarios disponibles",
    "next30Days": "próximos 30 días",
    "booking": "Reservando…",
    "selectWindowAbove": "Selecciona una ventana arriba",
    "bookSlot": "Reservar {{date}} · {{time}}",
    "publicBrand": "Delta WorkForce · Flota",
    "forYour": "Para tu",
    "bookedSuccess": "✓ ¡Reservado! Tu ventana de servicio está confirmada. Recibirás un recordatorio antes del ingreso.",
    "noWindowsPublic": "Sin ventanas disponibles. Vuelve después de que el administrador de flota publique nuevas.",
    "confirmBooking": "Confirmar reserva",
    "publicFooter": "Este enlace está vinculado a tu vehículo. Reenviarlo no registrará una reserva.",
    "errMissingToken": "Token faltante",
    "errPickLinkInvalid": "Enlace de selección inválido",
    "errBookingFailed": "Error al reservar"
  }
}
